import { FC, useState, useEffect } from 'react'
import cn from 'clsx'
import { PreHeaderIconLogo } from '@components/ui/Logo'
import constants from '@constants'
import useIsMobile from '@utils/useIsMobile'
import PrimaryLogoSR from '@components/ui/Logo/PrimaryLogoSR'
import PrimaryLogoSS from '@components/ui/Logo/PrimaryLogoSS'

interface PreHeaderProps {
  navigation?: any
}

interface PreNavLink {
  target: string
  label: string
  isExternal?: boolean
  opensInNewTab?: boolean
}

interface PreNavLinksProps {
  items: PreNavLink[]
}

const ns = `site-pre-header`

const PreHeader: FC<PreHeaderProps> = ({ navigation }) => {
  const rootClassnames = cn({
    [`${ns}`]: true,
  })

  const preLinkDelay = navigation?.preHeadLinkDelay * 1000 || 10000
  const PreNavLinks = ({ items }: PreNavLinksProps) => {
    const [currentIndex, setCurrentIndex] = useState(0)

    useEffect(() => {
      const intervalId = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length)
      }, preLinkDelay)

      return () => clearInterval(intervalId)
    }, [items.length])

    return (
      <ul>
        {items.slice(currentIndex, currentIndex + 1).map((item, index) => (
          <li key={index}>
            {item.opensInNewTab ? (
              <a href={item.target} target="_blank" rel="noopener noreferrer">
                {item.label}
              </a>
            ) : (
              <a href={item.target}>{item.label}</a>
            )}
          </li>
        ))}
      </ul>
    )
  }

  const isMobile = useIsMobile()
  const siteSwitchText =
    constants.BRAND === 'sweet-sweat' ? 'Visit Sports Research' : 'Visit Sweet Sweat'
  const sweetSweatURL = 'https://www.sweetsweat.com/'
  const sportsResearchURL = 'https://www.sportsresearch.com/'
  const siteSwitchDestination =
    constants.BRAND === 'sweet-sweat' ? sportsResearchURL : sweetSweatURL

  return (
    <section className={rootClassnames}>
      {isMobile ? (
        <a href={siteSwitchDestination} className={`${ns}__site-switch`}>
          <PreHeaderIconLogo />
          <p>{siteSwitchText}</p>
          <div className={`${ns}__site-switch__arrow`}>
            <svg
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.05594 8.35843L1.83197 9.13446L8.72062 2.24582C8.63557 4.03176 8.80549 7.22856 8.72044 9.24838L9.7835 9.2909L9.76242 0.459869L9.73053 0.427978L0.885157 0.417333L0.917049 1.46977C2.90498 1.37409 6.23305 1.60798 7.94458 1.46978L1.05594 8.35843Z"
                fill="#FFFFFF"
              />
            </svg>
          </div>
        </a>
      ) : (
        <div className={`${ns}__site-switch`}>
          <a
            href={sportsResearchURL}
            className={`${ns}__site-switch__logo-sr`}
          >
            <PrimaryLogoSR />
          </a>
          <a href={sweetSweatURL} className={`${ns}__site-switch__logo-ss`}>
            <PrimaryLogoSS />
          </a>
        </div>
      )}
      <PreNavLinks items={navigation.preNavLinksCollection.items} />
    </section>
  )
}

export default PreHeader
